import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import type { TaskSummary } from '../../../common/models/support.model';
import { TASK_STATUS_META, TASK_TYPE_META } from '../support-meta';

/** A task in one line: type icon, number, title, status. */
export function TaskBadge({ task, className, compact }: { task: TaskSummary; className?: string; compact?: boolean }) {
  const { t } = useTranslation();
  const type = TASK_TYPE_META[task.type];
  const status = TASK_STATUS_META[task.status];
  const TypeIcon = type.icon;
  return (
    <span
      className={cn('inline-flex max-w-full min-w-0 items-center gap-1.5 rounded-lg border bg-card px-2 py-1 text-xs', className)}
      data-testid="task-badge"
    >
      <TypeIcon className={cn('size-3.5 shrink-0', type.tone)} />
      <span className="shrink-0 font-medium tabular-nums text-muted-foreground">#{task.number}</span>
      {!compact && <span className="min-w-0 truncate">{task.title}</span>}
      <span className="ms-1 inline-flex shrink-0 items-center gap-1 text-muted-foreground">
        <span className={cn('size-1.5 rounded-full', status.dot)} />
        {t(status.labelKey)}
      </span>
    </span>
  );
}

/** Priority as signal bars (low → urgent). */
export function PriorityBars({ bars, tone, className }: { bars: number; tone: string; className?: string }) {
  return (
    <span className={cn('inline-flex items-end gap-px', tone, className)} aria-hidden>
      {[1, 2, 3, 4].map((i) => (
        <span key={i} className={cn('w-[3px] rounded-sm bg-current', i <= bars ? 'opacity-100' : 'opacity-20')} style={{ height: 3 + i * 2 }} />
      ))}
    </span>
  );
}
